import React from 'react'
import { Reseller } from '../../types'
import withEntityRequest from '../withEntityRequest'
import { resellerService } from '../../services'
import ParentOrganization from '../ParentOrganization'

interface ParentCardProps {
	entity: Reseller
}

function ResellerCard({ entity }: ParentCardProps) {
	return <ParentOrganization link={`/reseller/${entity.id}/children`} name={entity.name} />
}

export default withEntityRequest(ResellerCard, { type: 'Reseller', getById: id => resellerService.getById(id) })
